import { render, staticRenderFns } from "./ForwardSample.vue?vue&type=template&id=4ab54d50&scoped=true"
import script from "./ForwardSample.vue?vue&type=script&lang=js"
export * from "./ForwardSample.vue?vue&type=script&lang=js"
import style0 from "./ForwardSample.vue?vue&type=style&index=0&id=4ab54d50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab54d50",
  null
  
)

export default component.exports